import { callGetExam } from "@knowt/syncing/hooks/exams/graphqlUtils";
import { cache } from "react";

export const getExamData = cache(async (name: string) => {
    return await callGetExam({ name });
});
